export default "__VITE_ASSET__N3rRTVlW__"